__turbopack_context__.v({
  "body": "ToolFiltersDropdown-module-scss-module__V1eYBG__body",
  "close": "ToolFiltersDropdown-module-scss-module__V1eYBG__close",
  "content": "ToolFiltersDropdown-module-scss-module__V1eYBG__content",
  "header": "ToolFiltersDropdown-module-scss-module__V1eYBG__header",
});
